import { pluralize } from '@travelata-libs/utils';
import type { TouristRoom } from '@/entities/searchCriteria';
import { TOURISTS_TEXTS } from '../config/texts';

const ROOMS_FORMS = ['номер', 'номера', 'номеров'];
const TOURISTS_FORMS = ['туриста', 'туристов', 'туристов'];
const YEARS_FORMS = ['год', 'года', 'лет'];

export function roomsWord(n: number): string {
  return pluralize(ROOMS_FORMS, n, false);
}

export function touristsWord(n: number): string {
  return pluralize(TOURISTS_FORMS, n, false);
}

export function yearsWord(n: number): string {
  return pluralize(YEARS_FORMS, n, false);
}

export function formatRoomsLabel(roomsCount: number, canAddMoreRooms?: boolean): string {
  if (canAddMoreRooms) {
    return `${roomsCount} ${roomsWord(roomsCount)} ${TOURISTS_TEXTS.roomsForSuffix}`;
  }
  return 'Туристы';
}

export function formatTouristsValue(total: number, canAddMoreRooms?: boolean, tourists?: TouristRoom[]): string {
  if (canAddMoreRooms || !tourists) {
    return `${total} ${touristsWord(total)}`;
  }
  const adultsTextEndings = ['взрослый', 'взрослых', 'взрослых'];
  const infantsTextEndings = ['младенец', 'младенца', 'младенцев'];
  const kidsTextEndings = ['ребенок', 'детей', 'детей'];

  const childrenAges = tourists.flatMap((t) => t.childrenAges);
  const adults = tourists.flatMap((t) => t.adults).reduce((acc, adults) => acc + adults, 0);
  const kids = childrenAges.filter((c) => c > 1);
  const infants = childrenAges.filter((c) => c <= 1);
  const summary = kids.length + infants.length;

  if (kids.length) {
    return `${pluralize(adultsTextEndings, adults)} и ${pluralize(kidsTextEndings, summary)}`;
  } else if (infants.length) {
    return `${pluralize(adultsTextEndings, adults)} и ${pluralize(infantsTextEndings, infants.length)}`;
  }

  return `${pluralize(adultsTextEndings, adults)}`;
}

export function childAgeText(age: number): string {
  if (age === 0) {
    return TOURISTS_TEXTS.infantAge;
  }
  return `${age} ${yearsWord(age)}`;
}

export function childSelectLabel(age: number): string {
  return `${TOURISTS_TEXTS.childPrefix}${childAgeText(age)}`;
}
